import { useState, useCallback } from 'react';
import api from '../../services/api';
import { API_ROUTES } from '../../services/apiRoutes';

export const useUpdateQuota = (token) => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [response, setResponse] = useState(null);

    const manageQuota = useCallback(async (dataroomId, userId, credits) => {
        setIsLoading(true);
        setError(null);

        try {
            if (!token) {
                throw new Error("Token is missing");
            }
            const payload = {
                user_id: userId,
                dataroom_id: dataroomId,
                credits: credits,
            };

            const res = await api.post(API_ROUTES.UPDATE_USER_QUOTA(dataroomId, userId), payload, {
                headers: { Authorization: `Bearer ${token}` },
            });

            setResponse(res.data);
        } catch (err) {
            console.log(err)
            setError(err.response?.data?.error || "An unexpected error occurred");
        } finally {
            setIsLoading(false);
        }
    }, [token]);

    return { manageQuota, isLoading, error, response };
};
